import React, { useCallback } from 'react'
import { useTheme } from '@/context/ThemeContext'
import AdminSidebar from '@/features/admin/components/AdminSidebar'
import PlanTable from '@/features/admin/components/PlanTable'
import { useAdminPlans } from '@/features/admin/hooks/useAdminPlans'

const AdminPlansPage: React.FC = () => {
  const { currentTheme } = useTheme()
  const { plans, loading, error, createPlan, updatePlan, deletePlan } = useAdminPlans()

  const handleCreate = useCallback(
    async (input: { name: string; seats: number; monthlyAiCredits: number }) => {
      await createPlan(input)
    },
    [createPlan],
  )

  const handleUpdate = useCallback(
    async (id: string, input: { name: string; seats: number; monthlyAiCredits: number }) => {
      await updatePlan(id, input)
    },
    [updatePlan],
  )

  const handleDelete = useCallback(
    async (id: string) => {
      await deletePlan(id)
    },
    [deletePlan],
  )

  return (
    <div className="min-h-screen" style={{ backgroundColor: currentTheme.primary }}>
      <AdminSidebar />

      <main className="lg:pl-56 min-h-screen">
        <div className="px-4 pt-16 pb-8 sm:px-6 lg:px-8 lg:pt-8">
          <div className="mb-8">
            <h1 className="text-2xl font-bold" style={{ color: currentTheme.text }}>
              Plans
            </h1>
            <p className="mt-1 text-sm" style={{ color: currentTheme.secondrytext }}>
              Manage workspace plans — seats and monthly AI credit pools
            </p>
          </div>

          {error && (
            <div
              className="mb-6 rounded-2xl px-5 py-4 text-sm"
              style={{
                backgroundColor: currentTheme.errorBackground,
                color: currentTheme.errorText,
                border: `1px solid ${currentTheme.border}`,
              }}
            >
              {error}
            </div>
          )}

          <PlanTable
            plans={plans}
            loading={loading}
            onCreate={handleCreate}
            onUpdate={handleUpdate}
            onDelete={handleDelete}
          />
        </div>
      </main>
    </div>
  )
}

export default AdminPlansPage
